import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const JOURNEY_TABS = [
    { key: 'investment', label: 'Investment', img: require('../../../../images/landing-pages/pricing/companies-investment.svg') },
    { key: 'growth', label: 'Growth', img: require('../../../../images/landing-pages/pricing/companies-growth.svg') },
    { key: 'exit', label: 'Exit', img: require('../../../../images/landing-pages/pricing/companies-exit.svg') },
];

const VALID_KEYS = JOURNEY_TABS.map(t => t.key);

const PricingJourneySection = () => {
    const location = useLocation();
    const [active, setActive] = useState('investment');

    // Pre-select the journey stage from the ?journey= param (set by the Companies "See what's included" CTA).
    useEffect(() => {
        const key = new URLSearchParams(location.search).get('journey');
        if (key && VALID_KEYS.includes(key)) setActive(key);
    }, [location.search]);

    const current = JOURNEY_TABS.find(t => t.key === active);

    return (
        <section id="whats-included" className="lp-journey-sec">
            <div className="lp-container" style={{ textAlign: 'center', paddingBottom: 8 }}>
                <h2 className="lp-h2" style={{ margin: '0 auto 14px', maxWidth: 'none' }} data-lp-reveal>Your journey to investment, <span style={{ color: '#6366f1' }}>step by step</span> — in as little as 3 days</h2>
                <p className="lp-sub" style={{ margin: '0 auto' }} data-lp-reveal data-lp-delay="80">Every tier builds on the last. Here's exactly what you unlock at each stage.</p>
            </div>

            <div className="lp-journey-tabs-wrap">
                <div className="lp-journey-tabs">
                    {JOURNEY_TABS.map(t => (
                        <button key={t.key} className={`lp-journey-tab ${active === t.key ? 'is-active' : ''}`} onClick={() => setActive(t.key)}>{t.label}</button>
                    ))}
                </div>
            </div>

            <div className="lp-container" style={{ paddingBottom: 40 }}>
                <div className="lp-journey-img" data-lp-reveal>
                    <img src={current.img} alt={`${current.label} — what you get`} />
                </div>
            </div>

            <div className="lp-container">
                <div className="lp-pricing-banner" data-lp-reveal>
                    <div className='df'>
                        <div>
                            <div className="eyebrow">Pro &amp; Portfolio Pro — Continuous Monitoring</div>
                            <h3>Now continue to 'always on' — ready for your next round or exit</h3>
                            <p>Your Diligence Pack doesn't go in a drawer. Diligentsia monitors your KPIs, flags what needs updating and keeps your certification current — so when your next investor conversation starts, you're already prepared. Raise faster, exit cleaner.</p>
                        </div>
                        <img className="w130px" src={require('../../../../images/landing-pages/VC/investment-growth-exit.png')} alt="Diligentsia" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PricingJourneySection;
